<template>
  <div>
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="logo">
      <img src="/static/img/loginlogo.png" alt="logo">
    </div>
    <div class="content">
      <div class="select">
        <i class="iconfont">&#xe610;</i>
        <input type="tel" placeholder="请输入手机号" v-model="phone">
      </div>
      <div class="select select-box select-password">
        <i class="iconfont">&#xe619;</i>
        <input class="auth_input" type="tel" placeholder="请输入验证码" v-model="validate"/>
        <span v-show="sendAuthCode" class="btn"  @click="getAuthCode">获取验证码</span>
        <span v-show="!sendAuthCode" class="btn"> <span>{{auth_time}} </span> 秒后再获取</span>
      </div>
      <div class="select select-password select-identify">
        <div class="left">
          <i class="iconfont">&#xe619;</i>
          <input type="password" placeholder="重置密码" v-model="password">
        </div>
      </div>
    </div>
    <div class="footer">
      <button type="submit" @click="handleCompleteClick">{{state}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgetPassword',
  data () {
    return {
      state: '完成',
      phone: '',
      validate: '',
      password: '',
      sendAuthCode: true,
      auth_time: 0
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleCompleteClick () {
      this.state = '提交中...'
      this.bus.$emit('loading', true)
      this.resetpassword()
      // 反馈
    },
    // 验证
    resetpassword () {
      this.axios.post('/ApiAccount/ForgetPwd', {
        Phone: this.phone,
        verificationCode: this.validate,
        PassWord: this.password
      }).then(this.postForgInfoSucc)
        .catch(this.postForgInfoFail)
    },
    // 提交
    postForgInfoSucc (res) {
      this.state = '再次提交'
      res = res.data
      if (res.errorInfo === '') {
        alert('提交成功')
        this.$router.push({
          path: '/log_on'
        })
      } else {
        alert(res.errorInfo)
      }
    },
    postForgInfoFail () {
      alert('提交失败')
    },
    /* 获取验证码 */
    getAuthCode () {
      this.axios.post('/ApiSms/ForSendCode', {
        phone: this.phone
      }).then(this.postCodeSuccInfo)
        .catch(this.postCodeFailInfo)
      if (!this.phone) {
        alert('请输入手机号')
      } else if (this.phone.length !== 11) {
        alert('请输入11位手机号')
      } else {
        this.sendAuthCode = false
        this.auth_time = 60
        var timer = setInterval(() => {
          this.auth_time--
          if (this.auth_time <= 0) {
            this.sendAuthCode = true
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    postCodeSuccInfo (res) {
      res = res.data
      if (res.ret) {
        alert(res.errorInfo)
      }
    },
    postCodeFailInfo () {
      alert('获取失败')
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px; padding-bottom: 30px;}
.header .iconfont{ font-size: 25px;}
.header h1{ color: #3e3e3e; margin-left: 35px; margin-top: 10px;}
.logo{ margin: 50px 0;}
.logo img{ width: 80px; height: 80px; display: block; margin: 0 auto;}
.select{ border-bottom: 1px solid #f6f6f5; margin-bottom: 10px;}
.select .btn{ background-color: #fff; border: 1px solid #f6a975; color: #f6a975; border-radius: 3px; font-family: Arial,"Microsoft YaHei"; float: right; display: block; padding: 8px;}
.content{ padding: 0 15px;}
.content input{ border: 0; padding: 10px 0;}
input::-webkit-input-placeholder{ color:#dedede; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.content .iconfont{ font-size: 17px; margin-left: 5px; color: #c9c7c7; margin-right: 5px;}
.select-password .iconfont{ font-size: 20px;}
.log-on{ width: 85%; margin-left: auto; margin-right: auto;}
.footer{ margin-top: 15px;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 33px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/forget_password/components/Mess.vue